<div class="main-content">
    <my-basf-navigator
        [attr.base-url]="config.webchat.baseUrl"
        [attr.api-key]="config.webchat.apiKey"
        [attr.show-session-id]="config.webchat.showSessionId ?? false"
        [attr.token]="token()"
        [attr.use-streaming]="config.webchat.useStreaming ?? false"
    ></my-basf-navigator>
</div>
